<div id="location-table">
  <ep-location-table [locations]="locations$ | async" (rowClick)="rowClick($event)"></ep-location-table>
</div>
